import { RSAA, RSAAction } from 'redux-api-middleware';

import { AddApplicationPayload, ApplicationType, UpdateApplicationPayload } from './application.types';
import * as types from './applicationActionTypes';

export const addApplication = (
  account: string,
  type: ApplicationType,
  body: AddApplicationPayload,
): RSAAction<string, string, string> => ({
  [RSAA]: {
    body,
    endpoint: `company-accounts/${account}/applications/${type}`,
    method: 'POST',
    types: [types.ADD_APPLICATION_REQUEST, types.ADD_APPLICATION_SUCCESS, types.ADD_APPLICATION_FAILURE],
  },
});

export const updateApplication = (
  account: string,
  application: string,
  type: ApplicationType,
  body: UpdateApplicationPayload,
): RSAAction<string, string, string> => ({
  [RSAA]: {
    body,
    endpoint: `company-accounts/${account}/applications/${type}/${application}`,
    method: 'PUT',
    types: [types.UPDATE_APPLICATION_REQUEST, types.UPDATE_APPLICATION_SUCCESS, types.UPDATE_APPLICATION_FAILURE],
  },
});

export const fetchApplication = (
  account: string,
  application: string,
  type: ApplicationType,
): RSAAction<string, string, string> => ({
  [RSAA]: {
    endpoint: `company-accounts/${account}/applications/${type}/${application}`,
    method: 'GET',
    types: [types.FETCH_APPLICATION_REQUEST, types.FETCH_APPLICATION_SUCCESS, types.FETCH_APPLICATION_FAILURE],
  },
});

export const removeApplication = (
  account: string,
  application: string,
  type: ApplicationType,
): RSAAction<string, string, string> => ({
  [RSAA]: {
    endpoint: `company-accounts/${account}/applications/${type}/${application}`,
    method: 'DELETE',
    types: [types.REMOVE_APPLICATION_REQUEST, types.REMOVE_APPLICATION_SUCCESS, types.REMOVE_APPLICATION_FAILURE],
  },
});
